import React from 'react'
import { useLocation, Link } from 'react-router-dom'

const PATH_LABELS: Record<string, string> = {
  app: 'Início',
  assessments: 'Avaliações',
  wizard: 'Nova avaliação',
  editor: 'Editor',
  questions: 'Banco de Questões',
  templates: 'Modelos',
  analytics: 'Analytics',
  reports: 'Relatórios',
  help: 'Ajuda',
  settings: 'Configurações',
  billing: 'Planos e Cobrança',
  indicar: 'Indicações',
  'subscription-management': 'Assinatura',
  collaboration: 'Colaboração',
  'school-admin': 'Gestão da Escola',
}

const Breadcrumb: React.FC = () => {
  const { pathname } = useLocation()
  const parts = pathname.split('/').filter(Boolean)

  const crumbs: { label: string; to?: string }[] = parts.slice(0, 3).map((part, i) => {
    const to = '/' + parts.slice(0, i + 1).join('/')
    const label = PATH_LABELS[part] ?? part
    return i === parts.length - 1 ? { label } : { label, to }
  })

  if (crumbs.length === 0) return null

  return (
    <nav aria-label="Breadcrumb" className="flex items-center gap-1.5 font-mono text-xs tracking-[0.06em]">
      {crumbs.map((c, i) => (
        <React.Fragment key={i}>
          {i > 0 && <span className="text-ink-300 dark:text-ink-500">›</span>}
          {c.to ? (
            <Link to={c.to} className="text-ink-400 dark:text-ink-300 hover:text-ink-900 dark:hover:text-cream-50 transition-colors">
              {c.label}
            </Link>
          ) : (
            <span className="text-ink-900 dark:text-cream-50">{c.label}</span>
          )}
        </React.Fragment>
      ))}
    </nav>
  )
}

export default Breadcrumb
